import * as localforage from "localforage";
import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const resendAlarmPolicyAPI = async (alarmPolicyId, deviceId, t) => {
  const companyId = await localforage.getItem("companyId");

  await axios({
    url: `/api/v2/alarm/policy/resend`,
    method: "POST",
    data: {
      alarm_policy_id: alarmPolicyId,
      device_id: deviceId,
      company_id: companyId
    }
  });

  let successfulText = `modal.successfullyResendAlarmPolicy`;
  successHandling(t, successfulText);

  return true;
};
